/**
 * List Schema of Faturamento
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {Faturamento} from '@/model/resource/Faturamento'

export class ListFaturamentoSchema extends Schema {
  readonly name = 'ListFaturamento'

  readonly fieldSet: FieldSet<Faturamento> = {
    responsavel: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.responsavel?.$id,
      },
    }),
    cnpj: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.cnpj(schema.model.responsavel?.cnpj) ?? '-',
      },
    }),
    razaoSocial: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.responsavel?.razaoSocial ?? '-',
      },
    }),
    nomeFantasia: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.responsavel?.nomeFantasia ?? '-',
      },
    }),
    configDiaInicialDaGeracao: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.getDataInicio,
      },
    }),
    configDiaFinalDaGeracao: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.getDataFinal,
      },
    }),
    tipoRelatorio: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.getTipoRelatorio,
      },
    }),
    dataGeracaoFaturamento: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.dataGeracaoFaturamento),
      },
    }),
    linkGeracaoRelatorio: (schema): FieldComponent => ({
      is: Component.RenderAnchor,
      bind: {
        href: schema.model.linkGeracaoRelatorio,
        target: '_blank',
        label: 'Baixar Relatório',
        innerClass: 'text-primary font-semibold',
      },
    }),
  }
}
